import styles from './BrandLinearProgress.module.css';

import { LinearProgress } from '@mui/material';

export default function BrandLinearProgress() {
	return (
		<LinearProgress
			className={styles.spinner}
			color='primary'
		/>
	);
}
